import { IconButton } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styled from 'styled-components';

interface ExpandComponentProps {
  isExpanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

export function ExpandComponent(props: ExpandComponentProps): JSX.Element {
  const { isExpanded, setExpanded } = props;
  return (
    <StyledIconButton size="small" onClick={() => setExpanded(!isExpanded)}>
      <span>{isExpanded ? 'Collapse' : 'Show Evidence'}</span>
      {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
    </StyledIconButton>
  );
}

const StyledIconButton = styled(IconButton)`
  &.MuiIconButton-root {
    padding: 0px;
    font-size: 12px;
    & span {
      margin-top: 2px;
    }
  }
  & .MuiSvgIcon-root {
    margin-top: 2px;
    width: 20px;
    height: 20px;
  }
`;
